import { render, staticRenderFns } from "./EventInfoModal.vue?vue&type=template&id=4f85f481&scoped=true&"
import script from "./EventInfoModal.vue?vue&type=script&lang=js&"
export * from "./EventInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./EventInfoModal.vue?vue&type=style&index=0&id=4f85f481&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f85f481",
  null
  
)

export default component.exports